import './AdministrativePage.scss';
import { Link } from 'react-router-dom';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import Box from '../../../../shared/components/Box/Box';
import { canReviewSkillCatalog } from '../../../hr/utils/skillCatalog';

export default function AdministrativePage({ currentUser = {} }) {
  const role = String(currentUser.role || '').toLowerCase();
  const admin = Number(currentUser.roleId) === 1 || role === 'admin';
  const manager = Number(currentUser.roleId) === 3 || role === 'manager';
  const entries = [
    { label: 'Stock', path: '/stock', icon: Inventory2OutlinedIcon, description: 'Consulter les articles, les mouvements et les besoins en matériel.' },
    ...(canReviewSkillCatalog(currentUser) ? [{ label: 'Compétences', path: '/administratif/competences', icon: SchoolOutlinedIcon, description: 'Organiser le référentiel professionnel et examiner les propositions.' }] : []),
    ...(admin ? [{ label: 'Utilisateurs', path: '/administratif/utilisateurs', icon: SettingsOutlinedIcon, description: 'Gérer les comptes utilisateurs et leurs autorisations.' }] : []),
    ...(admin || manager ? [{ label: 'Coûts horaires', path: '/administratif/couts-horaires', icon: RequestQuoteOutlinedIcon, description: 'Gérer les profils métiers et leurs tarifs datés.' }] : []),
    { label: 'Note de frais', path: '/administratif/notes-de-frais', icon: ReceiptLongOutlinedIcon, description: 'Accéder à l’espace des frais de déplacement, de repas et de formation.' },
  ];

  return (
    <Box className="page-container administrative-page">
      <header className="administrative-page__header">
        <h1>Administratif</h1>
        <p>Accédez aux outils de gestion et aux référentiels internes.</p>
      </header>
      <nav className="administrative-page__grid" aria-label="Outils administratifs">
        {entries.map(({ label, path, icon: Icon, description }) => (
          <Link className="administrative-page__card" to={path} key={path}>
            <span className="administrative-page__icon" aria-hidden="true"><Icon /></span>
            <span className="administrative-page__copy">
              <h2>{label}</h2>
              <span>{description}</span>
            </span>
            <ArrowForwardOutlinedIcon className="administrative-page__arrow" aria-hidden="true" />
          </Link>
        ))}
      </nav>
    </Box>
  );
}
